import axios from "axios";

// For API routes that require credentials (cookies/auth)
export const axiosAuth = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  withCredentials: true,
});

// For connector or public routes that do NOT require credentials
export const axiosNoAuth = axios.create({
  baseURL: process.env.REACT_APP_CONNECTOR_ROUTE,
  withCredentials: false,
});
